import productApi from '@/api/product';
import apiOption from '@/api/option';

const defaultState = () => ({
	productResults: [],
	productSerialResults: [],
	productSerialOption: [],
	productUnit: [],
	productCategory: [],
	serialType: [],
	productCategoryResults: [],
	productStockResults: [],
	productStocLogkResults: [],
	productStocTransferkResults: [],
	dataProductConvert: [],
	dataProductConvertPagination: '',
	productPagination: '',
	responSukses: '',
	konfirmResponse: {},
	alert: '',
	imageName: '',
	productConvert: [],
});

const state = defaultState();

const getters = {

};

const mutations = {

	listproduct(state, data) {
		state.productResults = data.data.map((el) => {
			if (el.product_is_active == "active") {
				el.product_is_active = true
			} else {
				el.product_is_active = false
			}
			return el
		});
		state.productPagination = data.pagination;
	},
	listproductserial(state, data) {
		state.productSerialResults = data.data.map((el) => {
			if (el.product_is_active == "active") {
				el.product_is_active = true
			} else {
				el.product_is_active = false
			}
			return el
		});
		state.productPagination = data.pagination;
	},
	listproductserialOption(state, data) {
		state.productSerialOption = data.map((el) => {
			if (el.product_is_active == "active") {
				el.product_is_active = true
			} else {
				el.product_is_active = false
			}
			return el
		});
	},
	listproductcategory(state, data) {
		state.productCategoryResults = data.data.map((el) => {
			if (el.product_category_is_active == "active") {
				el.product_category_is_active = true
			} else {
				el.product_category_is_active = false
			}
			return el
		});
		state.productPagination = data.pagination;
	},
	listproductunit(state, data) {
		state.productUnit = data
	},
	listproductCategory(state, data) {
		state.productCategory = data
	},
	listSerialType(state, data) {
		state.serialType = data
	},
	listproductstock(state, data) {
		state.productStockResults = data.data;
		state.productPagination = data.pagination;
	},
	listproductstocklog(state, data) {
		state.productStocLogkResults = data.data;
		state.productPagination = data.pagination;
	},
	listproductstocktransfer(state, data) {
		state.productStocTransferkResults = data.data;
		state.productPagination = data.pagination;
	},
	listDataProductConvert(state, data) {
		state.dataProductConvert = data.data;
		state.dataProductConvertPagination = data.pagination;
	},
	listproductConvert(state, data) {
		state.productConvert = data
	},
	konfirmasiSukses(state, data) {
		state.responSukses = data;
		state.konfirmResponse = {};
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = data;
	},
	setImageName(state, { data : { results : { product_image } } } ) {
		state.imageName = product_image
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataProduct(state){
		Object.assign(state, defaultState())
	}
};

const actions = {
	getProduct({ commit }, params) {
		productApi.getDataProduct(params).then(({ data: { data } }) => {
			commit('listproduct', { data: data.results, pagination: data.pagination } );
		}).catch(() => {
			commit('listproduct', { data: [], pagination: {} } );
		});
	},
	getProductSerial({ commit }, params) {
		productApi.getDataProduct(params).then(({ data: { data } }) => {
			commit('listproductserial', { data: data.results, pagination: data.pagination } );
		}).catch(() => {
			commit('listproductserial', { data: [], pagination: {} } );
		});
	},
	getProductSerialOption({ commit }, params) {
		productApi.getDataProduct(params).then(({ data: { data } }) => {
			commit('listproductserialOption', data.results );
		}).catch(() => {
			commit('listproductserialOption', []);
		});
	},
	getProductUnit({ commit }) {
		productApi.getOptionProductUnit().then(({ data: { data } }) => {
			commit('listproductunit', data.results);
		}).catch(() => {
			commit('listproductunit', [] );
		});
	},
	getCategoryProduct({ commit }) {
		return new Promise((resolve) => {
			productApi.getOptionProductCategory().then(({ data: { data } }) => {
				commit('listproductCategory', data.results);
				resolve(data.results)
			}).catch(() => {
				commit('listproductCategory', [] );
				resolve([])
			});
		});
	},
	getOptionSerialType({ commit }) {
		productApi.getOptionSerialType().then(({ data: { data } }) => {
			commit('listSerialType', data.results);
		}).catch(() => {
			commit('listSerialType', [{type_id: 0, type_name: "Tanpa Serial"}] );
		});
	},
	getOptionWarehouse({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiOption.getOptionWarehouseAll(params).then(({ data: { data } }) => {
				resolve(data.results)
			}).catch( err => {
				reject([])
				const data = err.response.data
				dispatch("errorHandler", data, { root: true })
			});
		})
	},
	getDataConvertProduct({ commit }, params) {
		productApi.getDataConvertProduct(params).then(({ data: { data } }) => {
			commit('listDataProductConvert', { data: data.results, pagination: data.pagination } );
		}).catch(() => {
			commit('listDataProductConvert', { data: [], pagination: {} } );
		});
	},
	getDataConvertProductWarehouse({ commit }, params) {
		productApi.getDataConvertProductWarehouse(params).then(({ data: { data } }) => {
			commit('listDataProductConvert', { data: data.results, pagination: data.pagination } );
		}).catch(() => {
			commit('listDataProductConvert', { data: [], pagination: {} } );
		});
	},
	async exportConvertProduct({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await productApi.exportConvertProduct(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(err => {
			const data = err.response.data
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: data.message
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportConvertProductWarehouse({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await productApi.exportConvertProductWarehouse(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(err => {
			const data = err.response.data
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: data.message
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportProduct({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await productApi.exportProduct(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(err => {
			const data = err.response.data
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: data.message
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async addProduct({ commit , dispatch},value) {
		await dispatch('isAttempting', null, { root: true })
		await productApi.addProduct(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
		await dispatch('attempted', null, { root: true })
	},
	convertProduct({ commit , dispatch},value) {
		return new Promise(async (resolve) => {
			await dispatch('isAttempting', null, { root: true })
			await productApi.convertProduct(value).then(res => {
				const data = res.data;
				commit("konfirmasiSukses", data);
				dispatch('success', data)
				resolve()
			})
			.catch(err => {
				const data = err.response.data
				dispatch("errorHandler", data);
			});
			await dispatch('attempted', null, { root: true })
		})
	},
	async uploadImage({ commit , dispatch}, value) {
		await dispatch('isAttempting', null, { root: true })
		await productApi.uploadImage(value).then( ({ data }) => {
			commit("setImageName", data)
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
		await dispatch('attempted', null, { root: true })
	},
	async updateProduct({ commit , dispatch}, value) {
		await dispatch('isAttempting', null, { root: true })
		await productApi.updateProduct(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data);
			
		});
		await dispatch('attempted', null, { root: true })
	},
	async deleteProduct({ commit , dispatch}, value) {
		await dispatch('isAttempting', null, { root: true })
		await productApi.deleteProduct({ id: value }).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
		await dispatch('attempted', null, { root: true })
	},
	async statusProduct({ commit , dispatch}, value) {
		await dispatch('isAttempting', null, { root: true })
		await productApi.statusProduct(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
		await dispatch('attempted', null, { root: true })
	},
	getProductCategory({ commit }, param) {
		productApi.getDataProductCategory(param).then(({ data: { data } }) => {
			commit('listproductcategory', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('listproductcategory', { data: [], pagination: {} });
		});
	},
	async addCategory({ commit , dispatch}, value) {
		await dispatch('isAttempting', null, { root: true })
		await productApi.addProductCategory(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
		await dispatch('attempted', null, { root: true })
	},
	async statusProductCategory({ dispatch, commit }, value) {
		await dispatch('isAttempting', null, { root: true })
		await productApi.statusProductCategory(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
		await dispatch('attempted', null, { root: true })
	},
	async updateCategory({ commit, dispatch }, value) {
		await dispatch('isAttempting', null, { root: true })
		await productApi.updateProductCategory(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
		await dispatch('attempted', null, { root: true })
	},
	async deleteCategory({ commit, dispatch }, value) {
		await dispatch('isAttempting', null, { root: true })
		await productApi.deleteProductCategory({ id: value }).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data);
		});
		await dispatch('attempted', null, { root: true })
	},
	getProductStock({ commit }) {
		productApi.getDataProductStock().then(({ data: { data } }) => {
			commit('listproductstock', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('listproductstock', { data: [], pagination: {} });
		});
	},
	getProductStockLog({ commit }) {
		productApi.getDataProductStockLog().then(({ data: { data } }) => {
			commit('listproductstocklog', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('listproductstocklog', { data: [], pagination: {} });
		});
	},
	getProductStockTransfer({ commit }) {
		productApi.getDataProductStockTransfer().then(({ data: { data } }) => {
			commit('listproductstocktransfer', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('listproductstocktransfer', { data: [], pagination: {} });
		});
	},
	getProductConvert({ commit }) {
		return new Promise((resolve, reject) => {
			productApi.getOptionProductConvert().then(({ data: { data } }) => {
				commit('listproductConvert', data.results);
				resolve(data.results)
			}).catch(() => {
				commit('listproductConvert', [] );
				reject([])
			});
		});
	},
	errorHandler({ commit }, response) {
		commit("konfirmasiSukses", '');
		switch (response.message) {
			case 'error_validation':
			commit('saveConfirmResponse', response.data);
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};